import React, { useContext } from "react";
import { BRAND_AIA } from "@config/siteConfig";
import { ApplicationContext } from "@context/ApplicationContext";
import PromoLogoAia from "@components/Icons/PromoLogoAia";
import TicketIcon from "@components/Icons/TicketIcon";
import RedemptionsBar from "@components/RedemptionDetails/RedemptionsBar";

const RedemptionsOptions = ({ props, ticketClass }) => {
    const { data, innerRef, innerProps, isFocused, isSelected } = props;
    const { whiteLabel } = useContext(ApplicationContext);

    return (
        <div
            className={`redemptions__link dropdown-item react-select__option ${isFocused ? "react-select__option--is-focused" : ""}`}
            ref={innerRef}
            id={innerProps.id}
            onMouseMove={innerProps.onMouseMove}
            onMouseOver={innerProps.onMouseOver}
            onClick={innerProps.onClick}
            onTouchStart={innerProps.onTouchStart}
            onTouchMove={innerProps.onTouchMove}
            onFocus={innerProps.onFocus}
            role="option"
            aria-selected={isSelected}
            tabIndex={-1}
        >
            <RedemptionsBar
                promoDetails={data}
                ticketClass={ticketClass}
            />

            <span className="redemptions__promo-icon">
                {whiteLabel?.brand_code === BRAND_AIA 
                    ? (<PromoLogoAia /> )
                    : (<TicketIcon />)
                }
            </span>
        </div>
    );
};

export default RedemptionsOptions;
